import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormatBirthDateService {
  formatBirthDate(dateString: string): string {
    const datePattern = /^\d{2}-\d{2}-\d{4}$/;

    if (!datePattern.test(dateString)) {
      return dateString;
    }

    const [day, month, year] = dateString.split('-').map(Number);

    if (month < 1 || month > 12) {
      return dateString;
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day < 1 || day > daysInMonth) {
      return dateString;
    }

    const date = new Date(Date.UTC(year, month - 1, day));

    return date.toISOString();
  }
}
